import ReactDOM from "react-dom/client";
import reportWebVitals from "reportWebVitals";
import { ThemeProvider } from "@mui/material";
import App from "App";
import GlobalStyles from "lib/GlobalStyles";
import theme from "lib/theme";
import { store } from "app/store";
import { Provider } from "react-redux";
import { SectionProvider } from "lib/context/section";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <SectionProvider>
        <App />
      </SectionProvider>
    </ThemeProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
